<template>
  <div>
    <el-badge :value="csrSelfOrderCnt" class="item">
      <el-button size="small" class="line-style-btn" @click="openCrsSelfOrders">CSR Self-Order</el-button>
    </el-badge>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { routeINV } from '../router'
export default {
  name: 'HeaderSelfOrderBtn',
  computed: {
    ...mapState(['csrSelfOrderCnt'])
  },
  methods: {
    openCrsSelfOrders () {
      const routeData = this.$router.resolve({
        name: routeINV,
        params: { routeName: routeINV },
        query: { type: 'csr' }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.line-style-btn {
  border-color: #D82828;
  background: none;
  color: white;
}
</style>
